import React from "react";

function Footer() {
    return (
        <footer class="footer footer-center p-10 rounded">
            <div>
                <p>Copyright © {(new Date().getFullYear())}. All Rights Reserved </p>
                <p>by mama Myanmar.</p>
            </div>
        </footer>
    );
}

export default Footer; 